<div class="ui-project__header">
  <h5 class="font-weight-bold mb-0">{{ 'ProjectChanges.List.title' | translate }}</h5>

  <div class="actions__buttons">
    <app-button
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_ADD' }"
      (onClick)="createNewChange()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        prependSrc: '/assets/img/ic-plus-add.svg'
      }"
    />

    <app-button
      class="share-button"
      [disabled]="!this.checkedTaskIds.length"
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_SHARE' }"
      (onClick)="shareChanges()"
      confirmButtonType="success"
      placement="bottom"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: WindowHelper.isMobileWidth
          ? ''
          : ('ProjectChanges.shareNChanges' | translate: { amount: this.checkedTaskIds.length }),
        prependSrc: './assets/img/ic-share.svg'
      }"
    />

    <app-button
      class="share-button"
      [disabled]="!this.checkedTaskIds.length"
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_SHARE' }"
      (onClick)="createTaskFromChanges()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: WindowHelper.isMobileWidth
          ? ''
          : ('ProjectChanges.createTaskFromChanges' | translate: { amount: this.checkedTaskIds.length }),
        prependSrc: './assets/img/ic-check-square.svg'
      }"
    />

    <list-search />

    <list-filters-btn-v2 [filters]="ProjectChangesFiltersComponent" />
  </div>
</div>

<div class="project-changes-list-wrapper">
  <div class="container-fluid--30 project-changes-list__content pb-2 px-0">
    <app-list
      *ngIf="inited"
      [config]="config"
      [filters]="ProjectChangesFiltersComponent"
      [emptyTemplate]="emptyTemplate"
      [searchName]="'ProjectChanges.List.search' | translate"
      [selected]="selected"
      [showToggleMenu]="showToggleMenu.bind(this)"
      #list
    />
  </div>

  <div class="sticky-footer">
    <app-summary-toggle [summary]="summary" [summaryConfig]="summaryConfig" />
  </div>
</div>

<ng-template #emptyTemplate>
  <app-empty-list
    [imageSrc]="'/assets/img/empty-changes.svg'"
    [imageAlt]="'ProjectChanges.List.noRecords' | translate"
    [title]="'ProjectChanges.List.emptyTitle' | translate"
    [subtitle]="'ProjectChanges.List.emptyDescription' | translate"
  >
    <app-button
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_ADD' }"
      (onClick)="createNewChange()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: 'ProjectChanges.List.emptyButton' | translate,
        prependSrc: '/assets/img/ic-plus-add.svg'
      }"
    />
  </app-empty-list>
</ng-template>

<changes-name-cell #changesNameCellComponent />
<changes-type-cell #changesCategoryCellComponent />
<add-days-cell #addDaysCellComponent />
<changes-settlement-cell #changesSettlementCellComponent />
<changes-price-cell #changesPriceCellComponent />
<changes-deadline-cell #changesDeadlineCellComponent />
<changes-status-cell #changesStatusCellComponent />
<changes-created-cell #changesCreatedCellComponent />
<changes-name-header-cell #changesNameHeaderCellComponent />
